import React from 'react';
import PropTypes from 'prop-types';

function DialogTitle({ children, classes, className, component: Component = 'span', ...other }) {
  return (
    <Component className={className} {...other}>
      {children}
    </Component>
  );
}

DialogTitle.propTypes = {
  component: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default DialogTitle;
